import Vue from 'vue'
import App from '@/App.vue'
import Meta from 'vue-meta'
import Element from 'element-ui'
import router from '@/routes'
import store from '@/services/store'
import { convertDate } from '@/services/filters'
import { convertDateTime } from '@/services/filters'
import { convertCurrency } from '@/services/filters'
import locale from 'element-ui/lib/locale/lang/en'
import '@/styles/element.scss'
import '@/styles/style.scss'

Vue.use(Meta)
Vue.use(Element, {locale})
Vue.filter('convertDate', convertDate)
Vue.filter('convertDateTime', convertDateTime)
Vue.filter('convertCurrency', convertCurrency)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
